const base = {
  computed: {
    titleTag() {
      const instanceId = `${this.$options.name}-${this.instanceId}`;
      const { headingId } = this.$store.getters.containerSettings;

      if (instanceId === headingId) {
        return 'h1';
      }

      return 'h2';
    },
  },
};

export default base;
